import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CooperationPartnerDto } from 'src/app/shared/models/institution/cooperation-partner-dto.model';

import { IListView } from '../../../contracts/list-view';

@Component({
  selector: 'cooperation-partner-list-item',
  templateUrl: 'cooperation-partner-list-item.html',
  styleUrls: ['./../autocomplete-list-item.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CooperationPartnerListItem implements IListView {
  @Input() item: CooperationPartnerDto;
  @Output() clicked: EventEmitter<CooperationPartnerDto> = new EventEmitter<CooperationPartnerDto>();

  public triggerEvent() {
    this.clicked.emit(this.item);
  }
}
